import Env_Config from './settings'

export const url = {
  backendHost: Env_Config.api.url,
  cubeApiUrl: Env_Config.CUBE_API_URL,
  cubePublishedApiUrl: Env_Config.CUBE_PUBLISHED_API_URL,
  cubeTokenUrl: Env_Config.api.url,
  fakeApi: 'http://localhost:4000',
}

export const endPoint = {
  datasets: {
    getList: '/dataset/getDataSetsList',
    get: '/dataset/getDatasets',
    getDataSetDetails: '/dataset/getDataSetDetails',
    add: '/dataset/addDataSet',
    delete: '/dataset/deleteDataSet',
    update: '/dataset/updateDataSet',
    refreshDataSetsWithAthena: '/dataset/refreshDataSetsWithAthena',
    addJoinDataSet: '/dataset/addJoinDataSet',
    addJoinDataSetNew: '/dataset/addJoinDataSetNew',
    updateDataSetJoin: '/dataset/updateDataSetJoin',
    updateDataSetJoinNew: '/dataset/updateDataSetJoinNew',
    getAllDataFromAthena: '/dataset/getAllDataFromAthena',
    createJoinDatasetProps: '/dataset/createJoinDatasetProps',
    resyncJoinDataset: '/dataset/resyncJoinDataset',
    updateAthenaDataSet: '/dataset/updateAthenaDataSet',
    getAllDataSetsWOAuth: '/dataset/getAllDataSetsWOAuth',
    addAthenaDataSetWithFilter: '/dataset/addAthenaDataSetWithFilter',
    getDatasetByName:'/dataset/getDatasetByName',
    updateJoinDataSetFields: '/dataset/updateJoinDataSetFields'
  },
  reports: {
    getReportsList: '/report/getReportsList',
    deleteReport: '/report/deleteReport',
    getReportById: '/report/getReportById',
    updateReportById: '/report/updateReport',
    addReport: '/report/addReport',
    getReportsWithFolders: '/report/getReportsWithFolders',
    validateUserReport: '/report/validateUserReport',
    removeReportFromFolder: '/report/removeReportFromFolder',
    getAllReports: '/report/getAllReports',
    exportReport: '/report/exportDomainReports',
    importReport: '/report/importDomainReports',
    changeReportOwner: '/report/changeOwner',
    downloadReportList: '/report/getDownloadReportList',
  },
  alert: {
    addAlert: "/alert/addAlert",
    updateAlert: "/alert/updateAlert",
    alertList: '/alert/alertList',
    runAlert: '/alert/runAlert',
    runAllAlert: '/alert/runAllAlert',
    deleteAlert: '/alert/deleteAlert',
    getReportLink: '/alert/getReportLink',
  },
  measures: {
    getMeasuresList: '/measure/getMeasuresList',
    getAllMeasuresList: '/measure/getAllMeasuresList',
    addMeasures: '/measure/addMeasure',
    deleteReport: '/report/deleteReport',
    getReportById: '/report/getReportById',
    updateMeasure: '/measure/updateMeasure',
    deleteMeasure: '/measure/deleteMeasure',
    deleteMeasureByName: '/measure/deleteMeasureByName',
    getMeasureById: '/measure/getMeasureById',
    findMeasureByNameAndDataSetId: '/measure/findMeasureByNameAndDataSetId',
    deleteMeasureByName: '/measure/deleteMeasureByName',
    hideMeasure:'/measure/hideMeasure',
    getMeasuresListOnSelect:'/measure/getMeasuresListOnSelect'
  },
  dashboards: {
    getDashboardList: '/dashboard/getDashboardList',
    changeStatus: '/dashboard/changeStatus',
    getDashboarDetails: '/dashboard/getDashboarDetails',
    addDashboard: '/dashboard/addDashboard',
    updateDashboard: '/dashboard/updateDashboard',
    publishDashboard: '/dashboard/publishDashboard',
    deleteDashboard: '/dashboard/deleteDashboard',
    getAllDashboardsWOAuth: '/dashboard/getAllDashboardsWOAuth',
    validateUserDashboard: '/dashboard/validateUserDashboard',
    updateTabDesign: '/dashboard/updateTabDesign',
  },
  publishDashboard: {
    getDashboardList: '/publishDashboard/getDashboardList',
    changeStatus: '/publishDashboard/changeStatus',
    getDashboarDetails: '/publishDashboard/getDashboarDetails',
    addDashboard: '/publishDashboard/addDashboard',
    replacePublishDashboard: '/publishDashboard/replacePublishDashboard',
    publishDashboard: '/publishDashboard/publishDashboard',
    deleteDashboard: '/publishDashboard/deleteDashboard',
    getAllDashboardsWOAuth: '/publishDashboard/getAllDashboardsWOAuth',
    validateUserDashboard: '/publishDashboard/validateUserDashboard',
    getDashboarByUser: '/publishDashboard/getDashboarByUser'
  },
  userType: {
    addUserType: "/userType/addUserType",
    updateUserType: "/userType/updateUserType",
    getUserType: "/userType/getUserType",
    deleteUserType: "/userType/deleteUserType",
    updateUserTypeForDashboard: "/userType/updateUserTypeForDashboard",
    getUserTypeByDashboardId: "/userType/getUserTypeByDashboardId"
  },
  role: {
    addRole: "/role/addRole",
    deleteRole: "/role/deleteRole",
    updateRole: "/role/updateRole",
    getRole: "/role/getRole",
    getRoleDetailsByName: "/role/getRoleDetailsByName",
    getAllRolesName: "/role/getAllRolesName", 
    validateUserRole: "/role/validateUserRole"   
  },
  users: {
    markDashboardFavourite: '/user/markDashboardFavourite',
    markReportFavourite: '/user/markReportFavourite',
    adminLogin: '/user/userLogin',
    getUsersList: '/user/getUsersList',
    createUser: '/user/createUser',
    updateUser: '/user/updateUser',
    deleteUser: '/user/deleteUser',
  },
  config: {
    addVersion: '/config/addVersion',
    updateConfig: '/config/updateConfig',
    getConfig: '/config/getConfig'
  },
  token: {
    getToken: '/getToken',
  },
  reportFolder: {
    addFolder: '/reportFolder/addFolder',
    updateFolder: '/reportFolder/updateFolder',
    deleteFolder: '/reportFolder/deleteFolder',
    addReportToFolder: '/reportFolder/addReportToFolder',
    getAllFolders: '/reportFolder/getAllFolders',
  },
  sidebarConfig: {
    addSidebarConfig: '/sidebarConfig/addSidebarConfig',
    getSidebarConfig: '/sidebarConfig/getSidebarConfig',
  },
  dataSource: {
    addDataSource: '/dataSource/addDataSource',
    getDataSource: '/dataSource/getDataSource',
    updateDataSource: '/dataSource/updateDataSource',
    deleteDataSource: '/dataSource/deleteDataSource',
    updateActivationStatus: '/dataSource/updateActivationStatus'
  },
  userInfo: {
    getUserInfoByUuid: '/getUserInfoByUuid'
  },
  schoolReportStatus: {
    schoolReportStatus: '/schoolReportStatus'
  },
  activityLog:{
    userActivityLog:'/userActivityLog'
  },
  preAggregation: {
    getPreAggList: '/preAgg/getPreAggList',
    deletePreAgg:'/preAgg/deletePreAgg',
    addPreAgg:'/preAgg/addPreAgg'
  },
  dashboardShareRoutes:{
    dashboardShare:'/dashboardShareRoutes/dashboardShare',
    userTypeShare:'/dashboardShareRoutes/userTypeShare'
  },

  icon: {
    getIconList: '/icon/getIconList',
    addIcon: '/icon/addIcon',
  },
}
